<div class="container">
    <ng-container *ngIf="!claimSended" >
        
        <div class="title_container">
            <div class="title">{{"claim.popin_form.title" | translate}}</div>
            <img class="quit_cross" src="assets/images/quit_cross.svg" (click)="onNoClick()">
        </div>
        <div class="grey_background">
            <div class="title">
                <div class="label_title" *ngIf="data.reasonCode === 'AF'">{{"claim.popin_form.subtitle_AF" | translate}}</div>
                <div class="label_title" *ngIf="data.reasonCode === 'CL'">{{"claim.popin_form.subtitle_CL" | translate}}</div>
                <div class="label_sub">{{"claim.popin_form.subtitle_bis" | translate}}</div>
            </div>
            <form [formGroup]="userInformations" class="form">
                <div class="name_container">
                    <mat-form-field appearance="outline" class="name">
                        <mat-label>{{ "claim.popin_form.lastname" | translate}}</mat-label>
                        <input matInput placeholder="{{'claim.popin_form.lastname'| translate}}" [maxLength]="maxLength"
                            matTooltip="{{'character_limit'| translate}}" required="true" type="text"
                            formControlName="lastname"
                            [errorStateMatcher]="confirmValidParentMatcher">
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="name">
                        <mat-label>{{ "claim.popin_form.firstname" | translate}}</mat-label>
                        <input matInput placeholder="{{'claim.popin_form.firstname'| translate}}" [maxLength]="maxLength"
                            matTooltip="{{'character_limit'| translate}}" required="true" type="text"
                            formControlName="firstname"
                            [errorStateMatcher]="confirmValidParentMatcher">
                    </mat-form-field>
                </div>
                <mat-form-field appearance="outline" class="info">
                    <mat-label>{{ "claim.popin_form.email" | translate}}</mat-label>
                    <input matInput placeholder="{{'claim.popin_form.email'| translate}}" [maxLength]="maxLength"
                        matTooltip="{{'character_limit'| translate}}" required="true" type="email" #userEmail
                        (keyup)="emailValidCheck(this.userEmail.value)" formControlName="email"
                        [errorStateMatcher]="confirmValidParentMatcher">
                    <mat-icon *ngIf="!isEmailInputValid" matSuffix [ngStyle]="{'color': 'red'}">error</mat-icon>
                    <mat-error>
                        {{"personal_information.error_email" | translate}}
                    </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="info">
                    <mat-label>{{ "claim.popin_form.phoneNumber" | translate}}</mat-label>
                    <input matInput placeholder="{{'claim.popin_form.phoneNumber'| translate}}" [maxLength]="13" 
                         required="true" type="text" #userPhone
                        (keyup)="phoneValidCheck(this.userPhone.value)" formControlName="phoneNumber"
                        [errorStateMatcher]="confirmValidParentMatcher">
                    <mat-icon *ngIf="!isPhoneInputValid" matSuffix [ngStyle]="{'color': 'red'}">error</mat-icon>
                    <mat-error>
                        {{"personal_information.error_phoneNumber" | translate}}
                    </mat-error>
                </mat-form-field>
            </form>
            <div class="minHeight">
               <div class="validate" *ngIf="userInformations.valid" (click)="userInformations.valid? validate() : ''">{{"claim.popin_form.button"| translate}}
                </div>
            </div>         
        </div>
        <app-popin-footer class="popin_footer"></app-popin-footer>
    </ng-container>
    <ng-container *ngIf="claimSended">
        <app-confirm-bloc message1="claim.popin_confirmation.message1" [dialogRef]="dialogRef"
            [parcelInfo]="data.parcelInformations" [tag]="data.tag" [reasonCode]="data.reasonCode">
        </app-confirm-bloc>
    </ng-container>
</div>